export const formatNumber = (num: number) =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

export const formatDollars = (total: number) => {
  if (total >= 1000000) {
    return `$${Math.trunc((total / 1000000) * 10) / 10}M`
  } else if (total >= 1000) {
    return `$${Math.trunc((total / 1000) * 10) / 10}K`
  } else {
    return `$${Math.trunc(total)}`
  }
}

export function formatCompactNumber(number: number) {
  if (number < 1000) {
    return number
  } else if (number >= 1000 && number < 1_000_000) {
    return (number / 1000).toFixed(1) + 'K'
  } else if (number >= 1_000_000 && number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(1) + 'M'
  } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return (number / 1_000_000_000).toFixed(1) + 'B'
  } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
    return (number / 1_000_000_000_000).toFixed(1) + 'T'
  }
}
